import { createFileRoute } from "@tanstack/react-router";
import { PillarPage, buildPillarHead } from "@/components/site/PillarPage";
import { PILLAR_BY_SLUG } from "@/lib/pillars";

const pillar = PILLAR_BY_SLUG["growth-team-building"];

const faqs = [
  {
    q: "I'm a solo agent. Can KCN help me build my first team?",
    a: "Yes - that's our specialty. KCN coaches solo producers through their first admin hire, their first buyer agent, and the org design that lets the team actually scale instead of stalling.",
  },
  {
    q: "I already have a team. What does KCN add?",
    a: "Most existing teams plateau because the leader is still doing too much. KCN brings org design, scorecards, cadence, and CEO-level coaching to free up the leader and unlock the next ceiling.",
  },
  {
    q: "What does 'profitable growth' mean at KCN?",
    a: "Growth where revenue scales faster than payroll, where each new hire pays for themselves on a defined timeline, and where the leader's calendar gets lighter - not heavier - as the team grows.",
  },
];

export const Route = createFileRoute("/growth-and-team-building")({
  head: () => buildPillarHead(pillar, faqs),
  component: () => (
    <PillarPage
      pillar={pillar}
      intro="KCN is best known for one thing: helping agents and teams reach the next level - faster, more profitably, and without burning out the leader. Growth is engineered here, not hoped for."
      sections={[
        {
          eyebrow: "For solo agents",
          heading: "From producer to team leader.",
          body: "Most top producers hit a hard ceiling - they're the bottleneck of their own business. KCN walks you through the leverage moves in order: first admin hire, first showing partner, first buyer agent, first listing partner. Each step is coached, scripted, and documented.",
        },
        {
          eyebrow: "For existing teams",
          heading: "Break the leader's ceiling.",
          body: "Plateaued teams almost always have an org design problem, not an effort problem. KCN brings the org chart, the scorecards, the meeting cadence, and the recruiting playbook that lets the leader step out of dollar-productive activity and into the seat of an actual CEO.",
        },
        {
          eyebrow: "The compounding effect",
          heading: "Growth that pulls everything else forward.",
          body: "Growth at KCN is paired with administrative support, marketing, technology, and lead sources - because a great team without infrastructure just burns out faster. The whole platform compounds.",
        },
      ]}
      benefits={{
        heading: "What growth coaching at KCN unlocks.",
        items: [
          "Org design for scalable teams",
          "Hiring playbook and interview scripts",
          "Scorecards and KPI cadence",
          "Profit-first growth modeling",
          "Onboarding and ramp plans for new hires",
          "Team recruitment support from KCN leadership",
        ],
      }}
      faqs={faqs}
    />
  ),
});
